import angular from 'angular';

angular
  .module('cxSettings')
  .factory('settingsDialogsSvc', ['$q', 'ModalService', settingsDialogsSvc]);

function settingsDialogsSvc($q, ModalService) {
  function showModal(modalOptions) {
    var deferred = $q.defer();
    ModalService.showModal(modalOptions).then(function(modal) {
      modal.element.modal();
      modal.close.then(function(result) {
        if (result) deferred.resolve(result);
        else deferred.reject(null);
      }, deferred.reject);
    });
    return deferred.promise;
  }

  function showInvoiceTextDialog(invoiceText) {
    return showModal({
      template: require('./invoiceTextDialog.html'),
      controller: 'InvoiceTextDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        invoiceText: invoiceText,
      },
    });
  }

  function showAddTaskTemplateDialog(resources, costResources) {
    return showModal({
      template: require('./addTaskTemplateDialog.html'),
      controller: 'AddTaskTemplateDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        resources: resources,
        costResources: costResources,
      },
    });
  }
  function showCopyTaskTemplateDialog(template) {
    return showModal({
      template: require('./copyTaskTemplateDialog.html'),
      controller: 'CopyTaskTemplateDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: { template },
    });
  }

  function showAddSubTaskTemplateDialog(taskTemplate, resources, mailTemplates) {
    return showModal({
      template: require('./addSubTaskTemplateDialog.html'),
      controller: 'AddSubTaskTemplateDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        taskTemplate,
        resources,
        mailTemplates,
      },
    });
  }

  function showAddTaskScheduleDialog(templateId) {
    return showModal({
      template: require('./addTaskPeriodicityDialog.html'),
      controller: 'AddTaskPeriodicityDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: { taskTemplateId: templateId },
    });
  }
  function showCopyTaskPeriodicityDialog(schedule) {
    return showModal({
      template: require('./copyTaskPeriodicityDialog.html'),
      controller: 'CopyTaskPeriodicityDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: { schedule },
    });
  }

  function showTaskScheduleDialog(templateId) {
    return showModal({
      template: require('./taskScheduleDialog.html'),
      controller: 'TaskScheduleDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: { taskTemplateId: templateId },
    });
  }

  function showReorderSubtaskTemplatesDialog(template, initialMove) {
    return showModal({
      template: require('./reorderSubtaskTemplatesDialog.html'),
      controller: 'ReorderSubtaskTemplatesDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: { template: template, initialMove: initialMove || null },
    });
  }

  function showTaskParameterDefinitionsDialog(templateId) {
    return showModal({
      template: require('./taskParameterDefinitionsDialog.html'),
      controller: 'TaskParameterDefinitionsDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: { taskTemplateId: templateId },
    });
  }

  function showExportTaskTemplateSnippet(template) {
    return showModal({
      template: require('./exportTaskTemplateSnippetDialog.html'),
      controller: 'ExportTaskTemplateSnippetDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: { taskTemplate: template },
    });
  }
  function showImportTaskTemplateSnippet(data) {
    return showModal({
      template: require('./importTaskTemplateSnippetDialog.html'),
      controller: 'ImportTaskTemplateSnippetDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: { data },
    });
  }
  function showTaskTemplateTagsDialog(taskTemplateId, tags) {
    return showModal({
      template: require('./taskTemplateTagsDialog.html'),
      controller: 'TaskTemplateTagsDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: { taskTemplateId, tags },
    });
  }
  function showTaskTemplateRequiredAuthorizationsDialog(
    taskTemplateId,
    allAuthorizationsRequired,
    requiredAuthorizations,
  ) {
    return showModal({
      template: require('./taskTemplateRequiredAuthorizationsDialog.html'),
      controller: 'TaskTemplateRequiredAuthorizationsDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: { taskTemplateId, allAuthorizationsRequired, requiredAuthorizations },
    });
  }
  function editTaskTemplateRequiredDocumentTypes(taskTemplateId, requiredDocumentTypes) {
    return showModal({
      template: require('./taskTemplateRequiredDocumentTypesDialog.html'),
      controller: 'TaskTemplateRequiredDocumentTypesDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: { taskTemplateId, requiredDocumentTypes },
    });
  }

  return {
    newInvoiceText: function() {
      return showInvoiceTextDialog(null);
    },
    editInvoiceText: function(invoiceText) {
      return showInvoiceTextDialog(invoiceText);
    },
    addTaskTemplate: showAddTaskTemplateDialog,
    copyTaskTemplate: showCopyTaskTemplateDialog,
    addSubTaskTemplate: showAddSubTaskTemplateDialog,
    addTaskSchedule: showAddTaskScheduleDialog,
    copyTaskSchedule: showCopyTaskPeriodicityDialog,
    editTaskTemplateTags: showTaskTemplateTagsDialog,
    showTaskTemplateRequiredAuthorizationsDialog: showTaskTemplateRequiredAuthorizationsDialog,
    editTaskTemplateRequiredDocumentTypes: editTaskTemplateRequiredDocumentTypes,

    openTaskSchedules: showTaskScheduleDialog,
    openTaskParameterDefinitions: showTaskParameterDefinitionsDialog,
    openReorderSubtaskTemplates: showReorderSubtaskTemplatesDialog,
    exportTaskTemplateSnippet: showExportTaskTemplateSnippet,
    importTaskTemplateSnippet: showImportTaskTemplateSnippet,
  };
}
